import React from 'react';
import { StarIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Sarah Johnson',
    role: 'Homeowner',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
    quote: 'Working with Immovendu was the best decision we made. They found us our dream waterfront property and negotiated a price well below what we expected to pay.'
  }, {
    name: 'Michael Rodriguez',
    role: 'Luxury Property Investor',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
    quote: "The team's market knowledge is unparalleled. They've helped me acquire multiple investment properties, each exceeding my ROI expectations."
  }, {
    name: 'Emma Chen',
    role: 'First-time Luxury Buyer',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1961&q=80',
    quote: 'As someone new to the luxury market, I appreciated their patience and guidance. They found me a stunning penthouse that perfectly matched my lifestyle.'
  }];
  return <section className="py-20 bg-[#f2f2ed] w-full" data-id="element-839">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-840">
        <div className="mb-16" data-id="element-841">
          <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-842">
            Testimonials
          </h6>
          <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-843">
            What Our Clients Say
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-844">
          {testimonials.map((testimonial, index) => <div key={index} className="p-8 border-b border-[#3a4a56]" data-id="element-845">
              <div className="flex justify-start mb-6" data-id="element-846">
                <div className="flex space-x-1" data-id="element-847">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-[#00A3E0] fill-current" data-id="element-848" />)}
                </div>
              </div>
              <p className="text-[#3a4a56] mb-6 text-lg leading-relaxed" data-id="element-849">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-850">
                <div className="h-12 w-12 rounded-full overflow-hidden mr-4" data-id="element-851">
                  <img src={testimonial.image} alt={testimonial.name} className="h-full w-full object-cover" data-id="element-852" />
                </div>
                <div data-id="element-853">
                  <h4 className="font-normal text-[#3a4a56]" data-id="element-854">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-[#3a4a56]" data-id="element-855">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};